import React from 'react';
import ReactTable from "react-table";
import _ from 'lodash';
import QueryString from 'query-string';
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';
import {FIELDS as GLOBAL_FILTER_PANEL_FIELDS} from '../filter/GlobalFilterPanel';
import ComponentUtil from '../../utils/componentUtil';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Pagination from '../page/Pagination'
import NoData from '../page/NoData';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import AppConfig, { TableConfig } from '../../utils/appConfig';
import { withRouter } from 'react-router';
import moment from 'moment';

const log = new Logger('EXISTING_EXCHANGE_RATES_FORM', LOG_LEVELS.DEBUG);

const PAGE_INTERNAL_IDS = [
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_ID,
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_CODE,
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_SIMPLE_DATE,
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_MONTH,
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_YEAR,
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_COUNTRY_CODE,
    "defaultMonth",
    "defaultYear"
];
export class ExistingExchangeRates extends React.Component {
    
    constructor(props) {
        super(props);
        log.debug('constructor(): ExistingExchangeRates: ', props);
        this.state = {
            data: [],
            pagination: {
                pageSize: TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE
            },
            columns:  [
                {
                    Header: () => (<LanguageStringResolver string='exchangeRates_CurrencyFrom'></LanguageStringResolver>),
                    accessor: 'fromCurrencyAsString'
                }, 
                {
                    Header: () => (<LanguageStringResolver string='exchangeRates_CurrencyTo'></LanguageStringResolver>),
                    accessor: 'toCurrencyAsString'
                }, 
                {
                    Header: () => (<LanguageStringResolver string='exchangeRates_Value'></LanguageStringResolver>),
                    accessor: 'exchangeValue'
                }, 
                {
                    Header: () => (<LanguageStringResolver string='exchangeRates_StartDate'></LanguageStringResolver>),
                    accessor: 'exchangeDate',
                    Cell: (row) =>  {
                        let value = row && row.value;
                        if(_.isEmpty(value) || typeof value !== 'string') {
                            return (
                                <span></span>
                            );
                        }
                        return (
                            <span>{value.substr(0, 10)}</span>
                        );
                    }
                },             
                {
                    Header: () => (<LanguageStringResolver string='exchangeRates_EndDate'></LanguageStringResolver>),
                    accessor: 'endDate',
                    Cell: ({original}) =>  {
                        if(!original || 
                            _.isEmpty(original) || 
                            !original.endDateSet || 
                            typeof original.endDate !== 'string') {
                            return (
                                <span></span>
                            );
                        }
                        return (
                            <span>{original.endDate.substr(0, 10)}</span>
                        );
                    }
                }, 
                {
                    Header: () => (<LanguageStringResolver string='exchangeRates_NameSpace'></LanguageStringResolver>),
                    accessor: 'nameSpace'
                },
                {
                    Header: () => (<LanguageStringResolver string='exchangeRates_Source'></LanguageStringResolver>),
                    accessor: 'source'
                }
            ]       
        };
        this.fetchDataHandler = this.fetchDataHandler.bind(this);

        let parsedQueryParams = QueryString.parse(this.props.location.search);
        const today = moment.utc(new Date());
        parsedQueryParams.endDate = today.format(AppConfig.DateTimeConfig.DEFAULT_MOMENT_DATE_FORMAT);
        parsedQueryParams.startDate = today.subtract(1, 'months').format(AppConfig.DateTimeConfig.DEFAULT_MOMENT_DATE_FORMAT);
        let filterSelection = Object.assign({}, parsedQueryParams);
        PAGE_INTERNAL_IDS.forEach(key => delete filterSelection[key]);        
        ComponentUtil.updateUrlParams(this.props.location, this.props.history, filterSelection);
        //Also need to update the global filter controller 
        let newGlobalFilterSelection =  Object.assign({}, GLOBAL_FILTER_CONTROLLER.getAll(), {
            startDate: parsedQueryParams.startDate,
            endDate: parsedQueryParams.endDate
        }); 
        GLOBAL_FILTER_CONTROLLER.bulkChange(newGlobalFilterSelection);
    }

    fetchDataHandler(state) {
        log.debug("fetchDataHandler()");
        let { page, pageSize } = state;
        pageSize = Object.is(pageSize, NaN) ? TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE : pageSize;
        page = Object.is(page, NaN) ? 0 : page;
        let pagination = Object.assign({}, this.state.pagination,  {
            pageNumber: page + 1,
            pageSize: pageSize           
        });
        this.setState({
            pagination: pagination
        });
        this.props.onFetchData(pagination);
    }
    
    render() {
        log.debug('render(): ', this.props, this.state);
        const { pagination={}, columns=[]} = this.state;
        const {tableOptions={}, totalCount=0}= this.props;
        const data = Array.isArray(this.props.data) ? this.props.data : [];
        const pages = data ? Math.ceil(totalCount / this.state.pagination.pageSize) : 1;
        const NoDataComponent = props => (
            <NoData
              noDataText="exchangeRates_NoDataTitle"
              {...props}
            />
          );

        return (
            <div data-test="component-existing-exchange-rates">
                <ReactTable
                    manual
                    onFetchData={this.fetchDataHandler}
                    pages={pages || 1}
                    defaultPageSize={pagination.pageSize || TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE}
                    pageSizeOptions={TableConfig.PAGINATION.STANDARD_PAGE_SIZE_OPTIONS}
                    minRows={0}
                    maxRows={0}
                    PaginationComponent={Pagination}
                    showPageJump={true}
                    showPagination={totalCount < TableConfig.PAGINATION.STANDARD_MIN_PAGE_SIZE ? false : true}
                    data={data}
                    columns={columns}
                    sortable={false}
                    {...tableOptions}
                    NoDataComponent={NoDataComponent}
                    loading={this.props.loading}
                    className={totalCount === 0 ? 'hide-header' : ''}
                />
            </div>
        );
    }
}


ExistingExchangeRates.defaultProps = {
    data: [],
    onFetchData: () => {},
    loading: false,
    tableOptions: {},
    totalCount: 0
};

export default withRouter(ExistingExchangeRates);
